import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const CustomerDashboard = () => {
  return (
    <Container>
      <h2 className="my-4">Customer Dashboard</h2>
      <Row>
        <Col md={4} className="mb-4">
          <Card>
            <Card.Body>
              <Card.Title>My Orders</Card.Title>
              <Card.Text>
                View your order history and track your current orders.
              </Card.Text>
              <Button as={Link} to="/my-orders">View Orders</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-4">
          <Card>
            <Card.Body>
              <Card.Title>My Prescriptions</Card.Title>
              <Card.Text>
                Manage your uploaded prescriptions.
              </Card.Text>
              <Button as={Link} to="/my-prescriptions">View Prescriptions</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-4">
          <Card>
            <Card.Body>
              <Card.Title>My Payments</Card.Title>
              <Card.Text>
                View your payment history.
              </Card.Text>
              <Button as={Link} to="/my-payments">View Payments</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CustomerDashboard;
